export const LOADING_MESSAGE = '请稍等...';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const GET_QA_QUESTION_TAGS_SUCCESS = 'GET_QA_QUESTION_TAGS_SUCCESS';
export const GET_QA_QUESTION_LIST_SUCCESS = 'GET_QA_QUESTION_LIST_SUCCESS';
export const GET_QA_SEARCH_LIST_SUCCESS = 'GET_QA_SEARCH_LIST_SUCCESS';
export const PAGE_SIZE = 10;
